export const PRODUCTS_ERRORS = {
  NO_USER_DATA: 'No hay datos de usuario en localStorage',
  NO_ROLES: 'El usuario no tiene roles asignados',
  PARSE_ERROR: 'Error procesando datos del usuario',
} as const;

export const PATH_ROUTES = {
  LAYOUT: '/layout',
};
